import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { FormControl, IconButton, MenuItem, Select, Typography } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import CloseIcon from '@mui/icons-material/Close';
import { invisibleUser } from '../../api/user';
import { toast } from 'react-toastify'
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";


const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: 600,
    width: '95%',
    margin: '0 auto',
    bgcolor: 'background.paper',
    borderRadius: '20px',
    boxShadow: 24,
    p: 4,
    maxHeight: '80vh',
    overflow: 'auto',
};
const reasons = [
    "Content Violation/Invalid Inputs",
    "Personal Detail Exposure",
    "Inappropriate profile",
    "Message Spams",
    "Other"
]

const HideFromSearchModal = ({ open, onClose, user, onUpdated }) => {
    const [updatingVisibility, setUpdatingVisibility] = useState(false);
    const [reason,setReason] = useState("")
    const [customReason,setCustomReason] = useState("")


    const handleConfirm = async () => {
        if (!user?._id) return;
        try {
            setUpdatingVisibility(true);
            const modifyReason = reason!=="Other" ? reason : customReason
            if (!user?.isInvisible) {
                if (!modifyReason) {
                    toast.error('Please mention the reason.');
                    return
                }
                if (reason == "Other" && modifyReason?.length > 200) {
                    toast.error('The other reason must be within 200 characters.');
                    return
                }
            }
            const res = await invisibleUser({ userId: user._id,hideReason:modifyReason });
            if (res?.success !== false) {
                onClose?.();
                onUpdated?.();
            }
            toast.success('User visibility updated successfully');
            setReason('')
        } catch (err) {
            console.error('Error while updating user visibility', err);
        } finally {
            setUpdatingVisibility(false);
        }
    };

    return (
        <Modal
            open={open}
            onClose={onClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={style}>
                <IconButton
                    sx={{
                        position: 'absolute',
                        top: 10,
                        right: 10,
                    }}
                    onClick={onClose}
                >
                    <CloseIcon />
                </IconButton>
                <div>
                    {user?.isInvisible ? (
                        <>
                            <h5 className="font-36">Show in Search</h5>
                            <p>Make this user visible in search results again.</p>
                        </>
                    ) : (
                        <div>
                            <h5 className="font-36">Hide from Search</h5>
                            <p>Remove this user from search results.</p>
                                <FormControl
                                    size="small"
                                    
                                    sx={{
                                        // minWidth: 120,
                                        marginBottom:2,
                                        width:"100%",
                                        boxShadow: 'none',
                                        '& .MuiOutlinedInput-root': {
                                            borderRadius: '6px',
                                            boxShadow: 'none',
                                            '& fieldset': {
                                                borderColor: '#d1d5db', 
                                                borderWidth: '1px',
                                            },
                                            '&.Mui-focused fieldset': {
                                                borderColor: '#2563eb', 
                                                borderWidth: '1.5px',
                                            },
                                        },
                                    }}
                                >
                                    <Select
                                        value={reason}
                                        onChange={(e) => setReason(e.target.value)}
                                        displayEmpty
                                        renderValue={(selectedValue) => {
                                            if (selectedValue === '') {
                                                return <Typography color="textSecondary">Select a reason</Typography>;
                                            }
                                            return selectedValue;
                                        }}

                                        IconComponent={KeyboardArrowDownIcon}
                                        sx={{
                                            borderRadius: "8px",
                                            fontSize: "14px",

                                            "& .MuiSelect-select": {
                                                padding: "10px 14px",
                                            },

                                            // Arrow color
                                            "& .MuiSvgIcon-root": {
                                                color: "#747474ff",
                                                fontSize: "22px",
                                            },
                                        }}
                                    >
                                        {
                                            reasons?.map(item => {
                                                return <MenuItem
                                                    value={item}
                                                    sx={{ fontSize: "14px", fontWeight: 500 }}
                                                >
                                                    {item}
                                                </MenuItem>
                                            })
                                        }
                                    </Select>
                                </FormControl>
                                {reason==="Other" && <div className="mb-16">
                                    <label
                                        className="mb-8"
                                        sx={{ fontSize: "14px", fontWeight: 500 }}
                                    >
                                        Other Reason
                                    </label>
                                    <textarea
                                        className="form-control"
                                        placeholder="Write other reason..."
                                        value={customReason}
                                        onChange={(e) => setCustomReason(e.target.value)}
                                    ></textarea>
                                </div>}
                        </div>
                    )}
                    <Box sx={{ display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
                        <button
                            className="badge text-md fw-medium bg-warning-900 px-20 py-9 radius-8 text-white"
                            onClick={handleConfirm}
                            disabled={updatingVisibility || !user?.isInvisible && !reason}
                            aria-busy={updatingVisibility}
                        >
                            {updatingVisibility ? (
                                <span style={{ display: 'inline-flex', alignItems: 'center', gap: '8px' }}>
                                    <CircularProgress size={18} color="inherit" />
                                    Updating...
                                </span>
                            ) : (
                                'Confirm'
                            )}
                        </button>
                    </Box>
                </div>
            </Box>
        </Modal>
    );
};

export default HideFromSearchModal;
